// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__3DzWu","icon":"style_icon__1rIdh","title":"style_title__113py","logo":"style_logo__1yC9Q","logoContainer":"style_logoContainer__swzHI"};